module.exports = __webpack_public_path__ + "static/static-stars-legacy-f47d159f24833ac3ef92a0afe60afb0b.jpeg";